export default __webpack_public_path__ + "static/media/Z2 AIR ASIA PHILIPPINES.2f89ce4f.webp";